angular.module("app").controller("MobileCustomCssPageController", [
    '$scope', '$controller', "customCSSService", 'logger', 'errorHandler', 'preloadedCSS', '$window', function ($scope, $controller, customCSSService, logger, errorHandler, preloadedCSS, $window) {
        var dependency = {
            '$scope': $scope,
            'logger': logger,
            'errorHandler': errorHandler,
            'preloadedCSS': preloadedCSS,
            '$window': $window,
            'save': customCSSService.saveMobile
        };
        $controller('CustomCssBaseController', dependency);

        /**
         * Preview current CSS
         */
        $scope.previewCSS = function previewCSS() {
            customCSSService.previewMobile({data: $scope.css}).then(function (response) {
                if (response.status === "ok") {
                    $window.open(response.data.url, "PreviewWindow", "width=364,height=702");
                } else {
                    errorHandler(response.message)
                }
            });
        };

        /**
         * Show custom css file
         */
        $scope.getCode = function getCode() {
            customCSSService.getMobileURL().then(function (response) {
                if (response.status === "ok") {
                    $window.open(response.data.url, "PreviewWindow", "width=1000,height=800");
                } else {
                    errorHandler(response.message)
                }
            });
        };

    }
]);
